module.exports = __webpack_public_path__ + "img/animatic_thumb.b216d3c9.jpg";